import _ from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAlerts } from 'Selectors';
import { clearAlerts, popAlert, pushAlert } from 'Store';

type Args = AlertProp;

function useAlertBanner() {
    const dispatch = useDispatch();
    const alerts = useSelector(getAlerts);

    const addAlert = React.useCallback(
        ({ id, content, onClose, status, duration }: Args) => {
            const uId = _.uniqueId();
            dispatch(
                pushAlert({
                    id: `${uId}${id}`,
                    content,
                    onClose,
                    status,
                    duration
                })
            );
        },
        [dispatch]
    );

    const pop = React.useCallback((id: string | number) => dispatch(popAlert(id)), [dispatch]);
    const clearAll = React.useCallback(() => dispatch(clearAlerts()), [dispatch]);

    return {
        addAlert,
        pop,
        alerts,
        clearAll
    };
}

export default useAlertBanner;
